import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CompanyInfoFeature from './features/company-info';
import CustomerInfo1Feature from './features/customer-info-1';
import CustomerInfo2Feature from './features/customer-info-2';
import { selectIsPrivileged } from '../../../auth/ducks';
import { selectIsCustomerInfo2Visible } from '../../ducks';
import { FeatureProps } from '../../index';

function CustomerInfo2Route({ isPrivileged }: FeatureProps) {
  const { id } = useParams();
  const isCustomerInfo2Visible = useSelector(selectIsCustomerInfo2Visible);

  if (!isCustomerInfo2Visible) {
    return <Navigate to={`/form/${id}/investing/experience`} replace />;
  }

  return <CustomerInfo2Feature isPrivileged={isPrivileged} />;
}

function InformationsFeature() {
  const isPrivileged = useSelector(selectIsPrivileged);

  return (
    <Routes>
      <Route path="company-info" element={<CompanyInfoFeature isPrivileged={isPrivileged} />} />
      <Route path="customer-info-1" element={<CustomerInfo1Feature isPrivileged={isPrivileged} />} />
      <Route path="customer-info-2" element={<CustomerInfo2Route isPrivileged={isPrivileged} />} />
      <Route path="*" element={<Navigate to="../company-info" replace />} />
    </Routes>
  );
}

export default InformationsFeature;
